import { useState, useEffect } from 'react';
import { reportsService, MetricsData, TimelineDataPoint, CampaignMetric, TimeRange } from '@/lib/services/reports';

interface UseReportsState {
  overview: MetricsData | null;
  timeline: TimelineDataPoint[];
  campaigns: CampaignMetric[];
  isLoading: boolean;
  error: Error | null;
}

export function useReports(timeRange: TimeRange = '30d'): UseReportsState {
  const [state, setState] = useState<UseReportsState>({
    overview: null,
    timeline: [],
    campaigns: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    async function fetchData() {
      setState((prev) => ({ ...prev, isLoading: true, error: null }));

      try {
        const [overviewData, timelineData, campaignsData] = await Promise.all([
          reportsService.getOverview(timeRange),
          reportsService.getTimeline(timeRange),
          reportsService.getCampaigns(timeRange),
        ]);

        setState({
          overview: overviewData,
          timeline: timelineData,
          campaigns: campaignsData,
          isLoading: false,
          error: null,
        });
      } catch (err) {
        const error = err instanceof Error ? err : new Error('Failed to fetch reports');
        setState((prev) => ({
          ...prev,
          isLoading: false,
          error,
        }));
      }
    }

    fetchData();
  }, [timeRange]);

  return state;
}
